import script from "./SettingsTagsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsTagsSection.vue?vue&type=script&setup=true&lang=js"

import "./SettingsTagsSection.vue?vue&type=style&index=0&id=4130a332&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4130a332"]])

export default __exports__